import Api from './Api'

const END_POINT = 'customers'

export default {
    getSummary(customer_id = null) {
        let request = {
            params: {
                customer_id
            }
        }
        return Api.get(`${END_POINT}/summary`, request)
    }
}